import axios from 'axios';
import { useEffect, useState } from 'react';
import retry from 'retry';
import { useLoginContext } from '../components/auth0/LoginGate';
export const useResource = function (endpoint) {
  let isBlocked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const {
    idToken,
    profileId
  } = useLoginContext();
  useEffect(() => {
    const doCall = async () => {
      axios.get(endpoint, {
        headers: {
          Authorization: "Bearer ".concat(idToken),
          'X-profile-ID': profileId,
          'Use-Auth0': true
        }
      }).then(response => {
        setData(response.data);
      }).catch(error => console.error(error)).finally(() => {
        setIsLoading(false);
      });
    };
    const faultTolerantDoCall = () => {
      const operation = retry.operation();
      operation.attempt(doCall);
    };
    if (!isBlocked) {
      faultTolerantDoCall();
    }
  }, [endpoint, idToken, isBlocked, profileId]);
  return {
    isLoading,
    data
  };
};